<template>
    <div class="bottomCont flex-ac flex-c" :class="theme">
        <template v-for="(it, i) in list" :key="it.name">
            <i v-if="i">|</i>
            <span class="pointer">{{ it.label }}</span>
        </template>
    </div>
</template>
<script setup>
import {
    ref,
    computed,
    onMounted,
    onBeforeMount,
    onBeforeUnmount,
    watch,
} from "vue";
import { useRouter } from 'vue-router'
const router = useRouter()

import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const store = useStore();
const { theme } = storeToRefs(store);

const list = ref([
    { label: '关于我们', name: '' },
    { label: '服务协议', name: '' },
    { label: '隐私政策', name: '' },
    { label: '联系方式', name: '' },
]);

const navClick = (name) => {
    router.push({ name: name || 'home' })
}
</script>
<style lang="scss" scoped>
.bottomCont {
    width: 100%;
    height: 56px;
    background: #F8FAFC;
    font-size: 12px;
    color: #909FB5;

    i {
        margin: 0 10px;
    }
}


.bottomCont.dark {
    background: #03162C;
    color: #fff;
}
</style>